/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useState, useEffect, useCallback } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { message } from "antd";
import * as authApi from "../redux/api/authApi";
import AppConstants from "../constants/AppConstants";

const AuthContext = createContext();

export const getUser = async () => {
  try {
    const response = await axios.get(
      `${AppConstants.baseURL}/authclick/profile`,
      { withCredentials: true }
    );
    if (response.data.code === 200) {
      return { status: "SIGNED_IN", user: response.data.data };
    } else {
      return { status: "SIGNED_OUT", user: null };
    }
  } catch (error) {
    return { status: "SIGNED_OUT", user: null };
  }
};

export const AuthProvider = (props) => {
  const { myAuth = { status: "SIGNED_OUT", user: null } } = props;
  const [users, setUsers] = useState(false);
  

  const login = useCallback(async (formData) => {
    try {
      const resp = await axios({
        method: "post",
        url: `${AppConstants.baseURL}/authclick/login`,
        data: formData,
        withCredentials: true,
      });
      if (resp.data.code === 200) {
        const { data } = await authApi.getUserProfile();
        if (data.code === 200) {
          message.success(resp.data.message || "Logged In successfully");
          setUsers(data.data);
        } else {
          message.error(resp.data.message || "Something Went Wrong");
        }
      } else {
        message.error(resp.data.message || "Something Went Wrong");
      }
    } catch (error) {
      message.error(error.message);
    }
  }, []);

  const signupUser = useCallback(async (signupData) => {
    try {
      const resp = await axios({
        method: "post",
        url: `${AppConstants.baseURL}/authclick/signup`,
        data: signupData,
        withCredentials: true,
      });
      if (resp.data.code === 200) {
        message.success(resp.data.message || "Registration successful");
      } else {
        message.error(resp.data.message || "Something Went Wrong");
      }
    } catch (error) {
      message.error(error.message);
    }
  }, []);

  const logout = useCallback(async () => {
    const history = window.location.href.split("/").slice(3).join("/");
    localStorage.setItem("history", history);
    try {
      const resp = await axios.post(
        `${AppConstants.baseURL}/authclick/logout`,
        { withCredentials: true }
      );
      if (resp.data.code === 200) {
        message.success(resp.data.message || "Logout successful");
        setUsers(false);
      } else {
        message.error(resp.data.message || "Error logging out");
      }
    } catch (error) {
      message.error(error.message || "Something Went Wrong");
    }
  });

  const isAuthenticate = !!users || !!myAuth.user;
  const userData = users || myAuth.user;
  // console.log(userData, "userData");
  const authContextValue = {
    isAuthenticate,
    userData,
    logout,
    login,
    signupUser,
    setUsers,
  };

  return <AuthContext.Provider value={authContextValue} {...props} />;
};

export const useAuth = () => React.useContext(AuthContext);
export const AuthConsumer = AuthContext.Consumer;

export const PrivateRoutes = () => {
  const { isAuthenticate, userData } = useAuth();
  const navigate = useNavigate();
  // console.log(userData?.userModules, "userData------");
  const location = useLocation();
  // console.log(userData?.userModules.includes(location.pathname), "pathname");

  console.log(userData, "userData");
  let module_urls =
    userData?.userModules?.map((item) => item?.module_url) || [];
  let additionalUrls = ["/admin/role-modules", "/admin/all-users"];
  module_urls = module_urls?.concat(additionalUrls);
  // console.log(module_urls, "modules_urls");
  useEffect(() => {
    if (!isAuthenticate || isAuthenticate === false) {
      navigate("/login", { replace: true });
    } else if (module_urls.includes(location.pathname) == false) {
      // console.log("first");
      navigate("/404", { replace: true });
    }
  }, [isAuthenticate, navigate]);

  return <Outlet />;
};

export const LoginRoutes = () => {
  const { isAuthenticate, userData } = useAuth();
  const navigate = useNavigate();

  const history = localStorage.getItem("history");
  const location = useLocation();
  // console.log(userData?.userModules.includes(location.pathname), "pathname");
  useEffect(() => {
    if (isAuthenticate) {
      if (history || history === null || history === undefined)
        navigate(`/`, { replace: true });
      else navigate(`/${history}`, { replace: true });
    }
  }, [isAuthenticate, navigate]);

  return <Outlet />;
};
